import Model from '@/models/Model'

export default class GCivilStatus extends Model {
    resource() {
        return 'g_civil_status'
    }
}